import { BaseAnalyticsApi } from './baseAnalyticsApi'
import type { ICallsStatisticResponse, ICallsChartResponse } from './types'

class CallsApi extends BaseAnalyticsApi<ICallsStatisticResponse, ICallsChartResponse> {
  constructor() {
    super('calling')
  }
}

export const CallsAnalyticsApi = new CallsApi()
